import { render, staticRenderFns } from "./com-upload-file.vue?vue&type=template&id=d0e56180&scoped=true&"
import script from "./com-upload-file.vue?vue&type=script&lang=js&"
export * from "./com-upload-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e56180",
  null
  
)

export default component.exports